// Module
var code = "<script>let $ctrl</script> <atom-text ng-if=\"$ctrl.asteriskNoteExists\" modifier=\"asterisk-note\" class=\"asterisk-note-star-marker\"> <span class=\"asterisk-note-star-marker__star\">*</span> <sup>{{ $ctrl.asteriskNote.outputAsteriskNodeStar($ctrl.noteType, $ctrl.noteValue) }}</sup> </atom-text> ";
// Exports
module.exports = code;